const handleVideoEnd = ({ target }) => {
  target.currentTime = 0;
  target.play();
};

export const enhancer = (element) => {
  element.addEventListener("ended", handleVideoEnd, false);
};
